<div [ngClass]="getClassByType()">
  <div class="title-container">
    <ng-content></ng-content>
    <h3 [ngClass]="getTitleClassByType()">
      @if (handoverTemplate.type && handoverTemplate.type === 'SECTION') {
        <span class="section-prefix"> {{ handoverTemplate.type }} {{ index + 1 }} </span>
      }

      @if (!isEditingName) {
        <span (click)="toggleEditName()" tabindex="0">
          {{ handoverTemplate.templateName }}
        </span>
      }
      @if (isEditingName) {
        <mat-form-field class="inline-input">
          <input matInput [(ngModel)]="editedName" (blur)="saveName()" />
        </mat-form-field>
      }
    </h3>
    @if (handoverTemplate.type === 'SECTION') {
      <span class="section-actions">
        <button class="expand-button" mat-icon-button type="button" (click)="toggle.emit(index)" [class.open]="isOpen">
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
      </span>
    }
  </div>

  <!-- Sections-->
  @if (!handoverTemplate.type) {
    <div cdkDropList cdkDropListLockAxis="y" (cdkDropListDropped)="drop($event)">
      @for (template of children; track trackSections(idx, template); let idx = $index) {
        <div cdkDrag class="section">
          <app-project-template [handoverTemplate]="template" [index]="idx" [isOpen]="openSections[idx]" (toggle)="handleToggle($event)">
            <!--
            Need to content project the drag handle as Angular can't find it when it inside the child component 🤦
            https://github.com/angular/components/issues/13784
            -->
            <div class="dragHandle" cdkDragHandle>
              <mat-icon>drag_indicator</mat-icon>
            </div>
          </app-project-template>
          <div class="section-delete">
            <button mat-icon-button type="button" (click)="delete(idx, children)" class="delete-section" [disabled]="isDisabled">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      }
    </div>
  }
  @if (!handoverTemplate.type) {
    <div class="add-section">
      <button mat-button (click)="addSection(handoverTemplate, children)" [disabled]="lockedUI">
        <mat-icon>add_circle</mat-icon>
        Add Section
      </button>
      <button mat-raised-button color="primary" class="apply-template-button" (click)="applyTemplate()">
        <mat-icon>play_arrow</mat-icon>
        Apply Template
      </button>
    </div>
  }

  <!-- Rows-->
  @if (handoverTemplate.type === 'SECTION') {
    <div [@expandContent]="isOpen ? 'expanded' : 'collapsed'" #row class="children-container content">
      <div class="row">
        <div class="row-content-wrapper">
          <div class="row-ordinal">Nr.</div>
          <div class="row-name">Name</div>
          <div class="row-type">Row type</div>
          <div class="row-type">Content type</div>
          <span class="proces-code">Process code</span>
        </div>
        <span class="delete-row">&nbsp;</span>
      </div>
      @for (template of children; track template; let idx = $index) {
        <div class="row">
          @if (!rowEdit(idx)) {
            <div class="row-content-wrapper">
              <div class="row-ordinal">
                <span>{{ template.ordinal }}</span>
              </div>
              <div class="row-name">
                <span>{{ template.templateName }}</span>
              </div>
              <div class="row-type">
                <span>{{ template.type }}</span>
              </div>
              <div class="row-type">
                <span>{{ template.contentType }}</span>
              </div>
              <div class="process-code">
                <span> {{ getProcessCodeName(template.processCode) }} </span>
              </div>
            </div>
          }
          <!-- Row form -->
          @if (rowEdit(idx)) {
            <form class="row-content-wrapper" [formGroup]="rowForm">
              <div class="row-ordinal">
                <mat-form-field class="inline-validation">
                  <input matInput required maxlength="2" formControlName="templateOrdinal" name="templateOrdinal" />
                </mat-form-field>
              </div>
              <div class="row-name">
                <mat-form-field class="inline-validation">
                  <input matInput required maxlength="50" formControlName="templateName" name="templateName" />
                </mat-form-field>
              </div>
              <div class="row-type">
                <mat-select formControlName="rowType">
                  @for (type of rowTypes; track type) {
                    <mat-option [value]="type">
                      {{ type }}
                    </mat-option>
                  }
                </mat-select>
              </div>
              <div class="row-type">
                <mat-select formControlName="contentType">
                  @for (contentType of getContentTypesByRowType(); track contentType) {
                    <mat-option [value]="contentType">
                      {{ contentType }}
                    </mat-option>
                  }
                </mat-select>
              </div>
              <div class="process-code">
                <mat-select formControlName="processCode">
                  @for (processCode of ProcessCodeDictionary | keyvalue; track processCode) {
                    <mat-option [value]="processCode.key">
                      {{ processCode.key + ' - ' + processCode.value }}
                    </mat-option>
                  }
                </mat-select>
              </div>
            </form>
          }
          <!-- end row form-->
          @if (!rowEdit(idx)) {
            <button mat-icon-button type="button" (click)="edit(idx, children)" class="row-action">
              <mat-icon>edit</mat-icon>
            </button>
          }
          @if (rowEdit(idx)) {
            <button mat-icon-button type="button" (click)="save(idx, children)" class="row-action">
              <mat-icon>save</mat-icon>
            </button>
          }
          @if (rowEdit(idx)) {
            <button mat-icon-button type="button" (click)="cancel(idxn)" class="row-action">
              <mat-icon>cancel</mat-icon>
            </button>
          }
          @if (!rowEdit(idx)) {
            <button mat-icon-button type="button" (click)="delete(idx, children)" class="row-action">
              <mat-icon>delete</mat-icon>
            </button>
          }
        </div>
      }
      <div class="row">
        <button mat-icon-button type="button" (click)="addRow(handoverTemplate, children)">
          <mat-icon>{{ 'add_circle' }}</mat-icon>
        </button>
      </div>
    </div>
  }
</div>
